import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import { ADMIN_LIST_COVER_CLASS } from "../AdminListCoverThumb";

export default function WebinarAdminListRow({ webinar, onRemoved, onError }) {
	const [isRemoving, setIsRemoving] = useState(false);

	function handleRemove() {
		if (isRemoving) return;
		if (!window.confirm(`وبینار «${webinar.title}» حذف شود؟`)) return;
		setIsRemoving(true);
		onError("");
		api
			.webinarRemove({
				token: LoginHelper.getToken(),
				webinar_id: webinar.id,
			})
			.then(() => onRemoved())
			.catch((err) => {
				if (err?.data?.message) {
					onError(err.data.message);
				}
			})
			.finally(() => setIsRemoving(false));
	}

	const priceLabel =
		webinar.is_free || !webinar.price
			? "رایگان"
			: `${Number(webinar.price).toLocaleString("fa-IR")} تومان`;

	let statusBadge = null;
	if (webinar.has_started && webinar.is_join_window_open) {
		statusBadge = "در حال برگزاری";
	} else if (webinar.has_started) {
		statusBadge = "شروع شده";
	} else if (webinar.is_enrollable) {
		statusBadge = "قابل ثبت‌نام";
	}

	return (
		<article className="flex flex-col gap-3 rounded-[12px] border border-darkBlue/10 bg-white p-4 transition hover:border-darkBlue/20 sm:flex-row sm:items-center sm:justify-between">
			<div className="min-w-0 flex-1 text-right">
				<div className="flex flex-wrap items-start gap-3">
					{webinar.image_url && (
						<img
							src={webinar.image_url}
							alt=""
							className={ADMIN_LIST_COVER_CLASS}
						/>
					)}
					<div className="min-w-0 flex-1">
						<h3 className="font-Vazir-700 text-[15px] text-darkBlue">
							{webinar.title}
						</h3>
						{webinar.profile_detail?.name && (
							<p className="mt-1 font-Vazir-400 text-[12px] text-darkBlue/55 line-clamp-1">
								درمانگر: {webinar.profile_detail.name}
							</p>
						)}
					</div>
				</div>
				<div className="mt-2 flex flex-wrap gap-2">
					{statusBadge && (
						<span className="rounded-[8px] bg-lightCta px-2.5 py-1 font-Vazir-600 text-[12px] text-darkBlue">
							{statusBadge}
						</span>
					)}
					{webinar.j_start_datetime && (
						<span
							className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70"
							dir="ltr"
						>
							شروع: {webinar.j_start_datetime}
						</span>
					)}
					{webinar.j_finish_datetime && (
						<span
							className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70"
							dir="ltr"
						>
							پایان: {webinar.j_finish_datetime}
						</span>
					)}
					<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
						{priceLabel}
					</span>
					<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
						{Number(webinar.enrolls_count || 0).toLocaleString("fa-IR")}{" "}
						ثبت‌نام
					</span>
				</div>
			</div>
			<div className="flex shrink-0 flex-wrap gap-2 sm:justify-end">
				<Link
					to={`/webinar_detail/${webinar.id}/`}
					target="_blank"
					rel="noopener noreferrer"
					className="rounded-[10px] border border-darkBlue/15 px-3 py-2 font-Vazir-600 text-[13px] text-darkBlue no-underline transition hover:border-darkBlue/30"
				>
					مشاهده
				</Link>
				<Link
					to={`/webinar_edit/${webinar.id}/`}
					className="rounded-[10px] bg-lightCta px-4 py-2 font-Vazir-600 text-[13px] text-darkBlue no-underline transition hover:bg-[#E0EEF8]"
				>
					ویرایش
				</Link>
				<button
					type="button"
					disabled={isRemoving}
					onClick={handleRemove}
					className="rounded-[10px] border border-red-200 px-4 py-2 font-Vazir-600 text-[13px] text-red-600 transition hover:bg-red-50 disabled:opacity-60"
				>
					{isRemoving ? "…" : "حذف"}
				</button>
			</div>
		</article>
	);
}
